module.exports = __webpack_public_path__ + "img/奇怪的人.ab298ecb.jpg";